import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Instagram, Mail, MapPin } from 'lucide-react';
const TikTokIcon = ({
  className
}: {
  className?: string;
}) => <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" data-id="element-2776">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.86a8.16 8.16 0 0 0 4.77 1.52V6.93a4.85 4.85 0 0 1-1.84-.24z" data-id="element-2777" />
  </svg>;
const FOOTER_BG = '#3B4A4F';
const FOOTER_BG_DARK = '#2F3B3F';
export function SiteFooter() {
  return <footer className="pt-8 pb-5 text-[#E8E4D8]" style={{
    backgroundColor: FOOTER_BG
  }} data-id="element-2778">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-2779">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-6" data-id="element-2780">
          {/* Brand Col */}
          <div className="md:col-span-3" data-id="element-2781">
            <Link to="/" className="inline-flex items-center gap-3 mb-5" data-id="element-2782">
              <img src="https://cdn.magicpatterns.com/uploads/4gduygJNEAxYz3SyjoFAYx/ChatGPT_Image_May_13,_2026,_09_47_03_PM.png" alt="Structured Nutrition" className="w-14 h-14 object-contain" data-id="element-2783" />
              <div className="flex flex-col leading-tight" data-id="element-2784">
                <span className="text-base font-serif text-white tracking-wide" data-id="element-2785">
                  Structured
                </span>
                <span className="text-[10px] font-bold text-[#C8C4B0] uppercase tracking-[0.25em]" data-id="element-2786">
                  Nutrition
                </span>
              </div>
            </Link>
            <p className="text-sm text-[#C8C4B0] leading-relaxed max-w-xs mb-6" data-id="element-2787">
              Evidence-based nutrition coaching for real, sustainable health.
            </p>
          </div>

          {/* Quick Links Col */}
          <div className="md:col-span-3" data-id="element-2788">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-3" data-id="element-2789">
              Quick Links
            </h4>
            <ul className="space-y-0.5" data-id="element-2790">
              {[{
              name: 'About',
              path: '/about'
            }, {
              name: 'Services',
              path: '/services'
            }, {
              name: 'Training',
              path: '/training'
            }, {
              name: 'Books',
              path: '/books'
            }, {
              name: 'Shop',
              path: '/shop'
            }, {
              name: 'Contact',
              path: '/contact'
            }].map(link => <li key={link.name} data-id="element-2791">
                  <Link to={link.path} className="text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2792">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Services Col */}
          <div className="md:col-span-3" data-id="element-2793">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-3" data-id="element-2794">
              Services
            </h4>
            <ul className="space-y-0.5" data-id="element-2795">
              {['1:1 Nutrition Coaching', 'Personalized Meal Plans', 'Performance Nutrition', 'Strength Training Guidance', 'Supplement Recommendations', 'Accountability Coaching'].map(label => <li key={label} data-id="element-2796">
                  <Link to="/services" className="text-sm text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2797">
                    {label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact Col */}
          <div className="md:col-span-3" data-id="element-2798">
            <h4 className="text-[11px] font-bold text-white uppercase tracking-[0.2em] mb-5" data-id="element-2799">
              Contact
            </h4>
            <div className="flex items-center gap-4" data-id="element-2800">
              <a href="https://www.tiktok.com/@structured.nutrition" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2801">
                <TikTokIcon className="w-5 h-5" data-id="element-2802" />
              </a>
              <a href="https://www.instagram.com/structured.nutrition" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2803">
                <Instagram className="w-5 h-5" data-id="element-2804" />
              </a>
              <Link to="/contact" onClick={() => window.scrollTo(0, 0)} aria-label="Contact" className="text-[#C8C4B0] hover:text-white transition-colors" data-id="element-2805">
                <Mail className="w-5 h-5" data-id="element-2806" />
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t pt-5 flex flex-col md:flex-row items-center justify-between gap-4" style={{
        borderColor: FOOTER_BG_DARK
      }} data-id="element-2807">
          <p className="text-xs text-[#A8A492]" data-id="element-2808">
            © {new Date().getFullYear()} Jack Achenbach, MS, RDN, CPT. All
            rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-[#A8A492]" data-id="element-2809">
            <Link to="/privacy" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors" data-id="element-2810">
              Privacy Policy
            </Link>
            <Link to="/terms" onClick={() => window.scrollTo(0, 0)} className="hover:text-white transition-colors" data-id="element-2811">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}